/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The current status of the license key.
 */
export const LicenseStatus = {
  Inactive: "inactive",
  Active: "active",
  Expired: "expired",
  Disabled: "disabled",
} as const;
/**
 * The current status of the license key.
 */
export type LicenseStatus = ClosedEnum<typeof LicenseStatus>;

/** @internal */
export const LicenseStatus$inboundSchema: z.ZodNativeEnum<
  typeof LicenseStatus
> = z.nativeEnum(LicenseStatus);
/** @internal */
export const LicenseStatus$outboundSchema: z.ZodNativeEnum<
  typeof LicenseStatus
> = LicenseStatus$inboundSchema;
